import { markFieldAsValid, markFieldError, resetFieldState } from './fieldset';
import { classes, dataAttributes, selectors } from './lib';

const fieldIsRequired = (field) => {
	return field.classList.contains(classes.required);
};

export const validateInput = (field) => {
	let fieldIsValid = true;
	const input = field.querySelector('input, textarea');
	// Check if field is empty or invalid
	if (!input.value) {
		// Field is empty
		if (fieldIsRequired(field)) {
			markFieldError(field, 'empty');
			fieldIsValid = false;
		} else {
			resetFieldState(field);
		}
	} else if (!input.checkValidity()) {
		// Field value is invalid
		markFieldError(field, 'invalid');
		fieldIsValid = false;
	} else if (window.blacklist.length && input.type === 'email' && window.blacklist.filter((v) => input.value.split('@')[1] === v).length > 0) {
		// The entered email is blacklisted
		markFieldError(field, 'blacklisted');
		fieldIsValid = false;
	} else {
		// Field is neither empty nor invalid => Field is valid!
		markFieldAsValid(field);
	}
	return fieldIsValid;
};

export const validateMultiPattern = (field) => {
	let fieldIsValid = true;
	const input = field.querySelector('input, textarea');
	const patterns = JSON.parse(input.getAttribute(dataAttributes.fieldPattern));

	for (let key in patterns) {
		const pattern = patterns[key];

		input.setAttribute('pattern', pattern);
		if (input.value.match(pattern)) {
			markFieldAsValid(field);
		} else {
			markFieldError(field, key);
			fieldIsValid = false;
			break;
		}
	}
	return fieldIsValid;
};

export const validateMultiSwitch = (field) => {
	let fieldIsValid = true;
	const switches = field.querySelectorAll('.form-binary-input');

	if (!fieldIsRequired(field)) {
		// Field is not required
		return fieldIsValid;
	}

	for (let i = 0; i < switches.length; i++) {
		const cb = switches[i].querySelector('input');

		if (cb.checked) {
			markFieldAsValid(field);
			break;
		} else if (i === switches.length - 1) {
			markFieldError(field, 'empty');
			fieldIsValid = false;
		}
	}

	return fieldIsValid;
};

export const validateMultiRadio = (field) => {
	let fieldIsValid = true;
	const switches = field.querySelectorAll('.form-binary-input');

	if (!fieldIsRequired(field)) {
		// Field is not required
		return fieldIsValid;
	}

	for (let i = 0; i < switches.length; i++) {
		const cb = switches[i].querySelector('input');

		if (cb.checked) {
			markFieldAsValid(field);
			break;
		} else if (i === switches.length - 1) {
			markFieldError(field, 'empty');
			fieldIsValid = false;
		}
	}

	return fieldIsValid;
};

export const validateSwitch = (field) => {
	let fieldIsValid = true;
	// Only do validity checks if switch has an "off" state
	if (!field.querySelector('.custom-switch-wrapper')) {
		const cb = field.querySelector('input');

		if (!cb.checkValidity() && fieldIsRequired(field)) {
			markFieldError(field, 'empty');
			fieldIsValid = false;
		} else {
			markFieldAsValid(field);
		}
	}
	return fieldIsValid;
};

export const validateSelect = (field) => {
	let fieldIsValid = true;
	const select = field.querySelector('select');
	if (!select.value) {
		// Select has empty value
		if (fieldIsRequired(field)) {
			markFieldError(field, 'empty');
			fieldIsValid = false;
		} else {
			resetFieldState(field);
		}
	} else {
		// Select has value
		markFieldAsValid(field);
	}

	return fieldIsValid;
};

export const validateForm = (form, returnFields = false) => {
	const fields = {};

	// Validate every field in the form
	form.querySelectorAll(selectors.field).forEach((field) => {
		const fieldType = field.getAttribute(dataAttributes.fieldType);
		const fieldName = field.getAttribute(dataAttributes.fieldName);
		if (['text', 'textarea', 'number', 'email', 'tel', 'url', 'password'].includes(fieldType)) {
			fields[fieldName] = validateInput(field);
		} else if (fieldType === 'switch') {
			fields[fieldName] = validateSwitch(field);
		} else if (fieldType === 'multi_switch') {
			fields[fieldName] = validateMultiSwitch(field);
		} else if (fieldType === 'select') {
			fields[fieldName] = validateSelect(field);
		} else if (fieldType === 'radio') {
			fields[fieldName] = validateMultiRadio(field);
		}
	});

	return returnFields ? fields : !Object.values(fields).includes(false);
};

export const resetForm = (form) => {
	form.reset();
	form.querySelectorAll(selectors.field).forEach((field) => {
		resetFieldState(field);
		field.disabled = false;
	});
};

export const lockForm = (form) => {
	form.querySelectorAll(selectors.field).forEach((field) => (field.disabled = true));
};

export const unlockForm = (form) => {
	form.querySelectorAll(selectors.field).forEach((field) => (field.disabled = false));
};
